
<section class="section">
    <slot />
</section>
